import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const WaterlineManagement = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceWaterlineReset',
      isReset: true,
      buttonText: 'Reset All Waterline Data',
      features: [
        'Remove All Waterline Data'
      ]
    },
    {
      demo: 'practiceWaterlineDemo',
      isReset: false,
      buttonText: 'Add Waterline Demo',
      features: [
        'Waterline Straws',
        'Waterline Tablets',
        'Passed Tests',
        'Passed Retests',
        'Failed Tests',
        'Failed Retests'
      ]
    }
  ]

  return (
    <DemoCard headerText='Waterline Management' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default WaterlineManagement